import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import ShowError from "../../AppServices";
import {
  inserirOuAtualizar,
  criarContribuinteDs,
  criarTipoAlvaraConstrucaoDs,
  criarImovelDs,
  criarLancamentoAlvaraConstrucaoDs,
} from "../../DataSources";
import { Button, ScrollView } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import uiInfo from "../../ui-info";
import ImovelBox from "../imovel/ImovelBox";
import { abrirDetalhe } from "../../lancamentosUtils";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  alvaraAnterior: "",
  ano: undefined,
  areaExistente: undefined,
  arquiteto: "",
  artObra: "",
  artProjeto: "",
  classe: "",
  codigoSituacaoDeLancamento: "N",
  creaArquiteto: "",
  creaEngenheiro: "",
  dataDeCadastro: new Date(),
  dataInicioObra: new Date(),
  dataTerminoObra: undefined,
  documento: "",
  documentoResp: "",
  engenheiro: "",
  especificacao: "",
  id: undefined,
  sequencial: undefined,
  indicaoFiscal: "",
  m2DoAcrescimo: undefined,
  m2DaConstrucao: undefined,
  m2DaDemolicao: undefined,
  m2DaReforma: undefined,
  numero: undefined,
  obraBairro: "",
  obraCep: "",
  obraComplemento: "",
  obraEmail: "",
  obraEndereco: "",
  obraFax: "",
  obraNome: "",
  obraNumero: "",
  obraTelefone: "",
  imovelId: null,
  observacao: "",
  pavimentos: 1,
  processo: "",
  proprietarioBairro: "",
  proprietarioCep: "",
  proprietarioEndereco: "",
  proprietarioNumero: "",
  proprietarioComplemento: "",
  proprietarioCidade: "",
  proprietarioUF: "",
  proprietarioTelefone: "",
  proprietarioFax: "",
  proprietarioId: null,
  proprietarioEmail: "",
  proprietarioBairroC: "",
  proprietarioCepC: "",
  proprietarioEnderecoC: "",
  proprietarioNumeroC: "",
  proprietarioComplementoC: "",
  proprietarioCidadeC: "",
  proprietarioUFC: "",
  qtdeSimples: 0,
  responsavelBairro: "",
  responsavelCEP: "",
  responsavelCidade: "",
  responsavelComplemento: "",
  responsavelEndereco: "",
  responsavelExecObra: 1,
  responsavelId: null,
  responsavelNumero: "",
  responsavelUF: "",
  situacao: "",
  tipoConstrucaoSimples: 0,
  tipoDeConstrucaoDaConstrucao: 0,
  tipoDeConstrucaoDaDemolicao: 0,
  tipoDeConstrucaoDaReforma: 0,
  tipoDeConstrucaoDoAcrescimo: 0,
  tipoDeOcupacaoDaConstrucao: 0,
  tipoDeOcupacaoDaDemolicao: 0,
  tipoDeOcupacaoDaReforma: 0,
  tipoDeOcupacaoDoAcrescimo: 0,
  tipoId: null,
  tipoOcupacaoSimples: 0,
  unidadeMedidaBCSimples: "",
  unidades: 1,
  validade: null,
  vencimento: new Date(),
  zonaObra: 1,

  popupProprietarioVisivel: false,
  popupResponsavelVisivel: false,

  _uiClasse: 1,
  _uiUnidadeBaseCalculo: "",
  _uiNumeroAlvara: "",
};

export default class LancamentoAlvaraConstrucao extends React.Component {
  constructor(props) {
    super(props);
    //this.veiculoDs = criarVeiculosDs();
    this.formRef = React.createRef();
    this.imovelBoxRef = React.createRef();
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.confirmar = this.confirmar.bind(this);
    this.confirmarTela = this.confirmarTela.bind(this);
    this.confirmarPopup = this.confirmarPopup.bind(this);
    this.cancel = this.cancel.bind(this);

    this.state = { ...(_cadastroCorrente || template) };
    this.renderOutroEndereco = this.renderOutroEndereco.bind(this);
    this.renderDadosResponsavel = this.renderDadosResponsavel.bind(this);
    this.contribuinteDs = criarContribuinteDs();
    this.imovelDs = criarImovelDs();
    this.alvaraConstrucaoDs = criarLancamentoAlvaraConstrucaoDs();

    //Funções do proprietário
    /*
    /*
    */
    this.setProprietarioId = this.setProprietarioId.bind(this);
    this.setNomeProprietario = this.setNomeProprietario.bind(this);
    this.pesquisarProprietario = this.pesquisarProprietario.bind(this);
    this.onProprietarioSelecionadoPesquisa =
      this.onProprietarioSelecionadoPesquisa.bind(this);
    this.proprietarioBoxRef = React.createRef();
    this.renderProprietario = sysCodigoDescricao(
      () => this.state.proprietarioId,
      this.setProprietarioId,
      () => this.state._uiNomeProprietario,
      this.pesquisarProprietario
    );
    this.setNomeProprietarioErro = this.setNomeProprietarioErro.bind(this);
    this.atualizarNomeProprietario = this.atualizarNomeProprietario.bind(this);
    /*
    /*
    */
    //Fim da funções do proprietário

    //Funções do Responsável
    /*
    /*
    */
    this.setResponsavelId = this.setResponsavelId.bind(this);
    this.setNomeResponsavel = this.setNomeResponsavel.bind(this);
    this.pesquisarResponsavel = this.pesquisarResponsavel.bind(this);
    this.onResponsavelSelecionadoPesquisa =
      this.onResponsavelSelecionadoPesquisa.bind(this);
    this.responsavelBoxRef = React.createRef();
    this.renderResponsavel = sysCodigoDescricao(
      () => this.state.responsavelId,
      this.setResponsavelId,
      () => this.state._uiNomeResponsavel,
      this.pesquisarResponsavel
    );
    this.setNomeResponsavel = this.setNomeResponsavel.bind(this);
    this.atualizarNomeResponsavel = this.atualizarNomeResponsavel.bind(this);
    /*
    /*
    */
    //Fim das funções do responsável

    this.responsavelOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 1, descricao: "Proprietário - Titular do Imóvel e da Obra" },
        { id: 2, descricao: "Incorporadora - Abrangidos pela lei nº 4.591/64" },
        { id: 3, descricao: "Dono - Não titula do imóvel" },
        { id: 4, descricao: "Construtora - Com registro no CREA" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => this.setState({ responsavel: e.value }),
    };

    this.zonaObraOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 1, descricao: "Urbana" },
        { id: 2, descricao: "Rural" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.pesquisarImovel = this.pesquisarImovel.bind(this);
    this.setImovelId = this.setImovelId.bind(this);

    this.proprietarioOptions = {
      editorType: "dxTextBox",
      mode: "text",
      onFocusOut: (e) => e.component.repaint(),
      onValueChanged: (e) => this.setProprietarioId(e),
      buttons: [
        {
          name: "btnPesquiasrContribuinte",
          location: "after",
          options: {
            icon: "search",
            onClick: this.pesquisarProprietario,
          },
        },
      ],
    };

    this.responsavelIdOptions = {
      editorType: "dxTextBox",
      mode: "text",
      onFocusOut: (e) => e.component.repaint(),
      onValueChanged: (e) => this.setResponsavelId(e),
      buttons: [
        {
          name: "btnPesquiasrContribuinte",
          location: "after",
          options: {
            icon: "search",
            onClick: this.pesquisarResponsavel,
          },
        },
      ],
    };

    this.tipoDocumentoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 2, descricao: "CPF" },
        { id: 1, descricao: "CNPJ" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.imovelOptions = {
      editorType: "dxTextBox",
      mode: "text",
      onFocusOut: (e) => e.component.repaint(),
      onValueChanged: (e) => this.setImovelId(e),
      buttons: [
        {
          name: "btnPesquisarImovel",
          location: "after",
          options: {
            icon: "search",
            onClick: this.pesquisarImovel,
          },
        },
      ],
    };

    this.documentoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 0, descricao: "CPF" },
        { id: 1, descricao: "CNPJ" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: "N", descricao: "Normal" },
        { id: "I", descricao: "Isento" },
        { id: "M", descricao: "Imune" },
        { id: "C", descricao: "Cancelado" },
        { id: "R", descricao: "Remisso" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.ocupacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "Residencial" },
        { id: 2, descricao: "Comercial" },
        { id: 3, descricao: "Residencial e Comercial" },
        { id: 4, descricao: "Outras Ocupações" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.construcaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "Alvenaria" },
        { id: 2, descricao: "Madeira" },
        { id: 3, descricao: "Alvenaria e Madeira (Mista)" },
        { id: 4, descricao: "Outras Construções" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.onTipoAlvaraSelecionado = this.onTipoAlvaraSelecionado.bind(this);
    this.tipoAlvaraConstrucaoDs = criarTipoAlvaraConstrucaoDs();

    this.tiposAlvaraOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: this.tipoAlvaraConstrucaoDs,
      valueExpr: "id",
      displayExpr: "titulo",
      onValueChanged: this.onTipoAlvaraSelecionado,
    };

    this.onImovelSelecioando = this.onImovelSelecioando.bind(this);
    this.itemLeitura = this.itemLeitura.bind(this);
    this.itemLeituraMoeda = this.itemLeituraMoeda.bind(this);
  }

  itemLeitura(data) {
    if (this.state.previewData == undefined) {
      return <span></span>;
    }
    return <span>{this.state.previewData[data.dataField]}</span>;
  }

  itemLeituraMoeda(data) {
    let valor;
    if (this.state.previewData != undefined) {
      valor = this.state.previewData[data.dataField];
    }
    let str = "";
    if (valor !== undefined) {
      str = valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    }

    return <span>{str}</span>;
  }

  pesquisarImovel() {
    this.imovelBoxRef.current.limparFiltro();
    this.setState({ popupImovelVisivel: true });
  }

  onTipoAlvaraSelecionado(e) {
    if (e.event) {
      let tipoId = e.value;

      if (tipoId !== undefined) {
        this.tipoAlvaraConstrucaoDs
          .byKey(tipoId)
          .then((tipo) => {
            this.setState(
              {
                _uiClasse: tipo.classe,
                unidadeMedidaBCSimples: tipo.unidadeBaseCalculo,
              },
              () => this.formRef.current.instance.getEditor("tipoId").focus()
            );
          })
          .catch((error) => {
            ShowError(error);
          });
      }
    }
  }

  //Funções do proprietário
  /*
  /*
  */

  setProprietarioId(data) {
    if (data.event) {
      this.setState({ proprietarioId: data.value });
      this.atualizarNomeProprietario();
    }
  }

  atualizarNomeProprietario() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.proprietarioId]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setNomeProprietario(result[0]);
        } else {
          this.setNomeProprietario(undefined);
        }
      })
      .catch((_) => this.setNomeProprietarioErro());
  }

  setNomeProprietario(proprietario) {
    if (proprietario === undefined || proprietario === null) {
      this.setState({
        proprietarioNome: "",
        proprietarioBairro: "",
        proprietarioCep: "",
        proprietarioEndereco: "",
        proprietarioNumero: "",
        proprietarioComplemento: "",
        proprietarioCidade: "",
        proprietarioUF: "",
        proprietarioTelefone: "",
        proprietarioFax: "",
        proprietarioId: null,
        proprietarioEmail: "",
        documento: "",
      });
    } else {
      const documento = proprietario.cpfCnpjFormatado;

      this.setState(
        {
          proprietarioNome: proprietario.nome,
          proprietarioBairro: proprietario.bairro.descricao,
          proprietarioCep: proprietario.cep,
          proprietarioEndereco: proprietario.endereco,
          proprietarioNumero: proprietario.numero,
          proprietarioComplemento: proprietario.complemento,
          proprietarioCidade: proprietario.cidade,
          proprietarioUF: proprietario.uf,
          proprietarioTelefone: proprietario.telefone,
          proprietarioFax: proprietario.celular,
          proprietarioId: proprietario.sequencial,
          proprietarioEmail: proprietario.email,
          documento,
        },
        () => this.formRef.current.instance.getEditor("proprietarioId").focus()
      );
    }
  }

  setNomeProprietarioErro() {
    this.setState({ _uiNomeProprietario: "<<ERRO>>" });
  }

  onProprietarioSelecionadoPesquisa(e) {
    this.setState({
      proprietarioId: e.row.data.sequencial,
      popupProprietarioVisivel: false,
    });
    this.atualizarNomeProprietario();
  }

  pesquisarProprietario() {
    this.proprietarioBoxRef.current.limparFiltro();
    this.setState({ popupProprietarioVisivel: true });
  }
  /*
  /*
  */
  //Fim da funções do proprietário

  //Funções do Responsável
  /*
  /*
  */
  setResponsavelId(data) {
    this.setState({ responsavelId: data.value });
    this.atualizarNomeResponsavel();
  }

  atualizarNomeResponsavel() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.responsavelId]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setNomeResponsavel(result[0]);
        } else {
          this.setNomeResponsavel(undefined);
        }
      })
      .catch((_) => this.setNomeResponsavelErro());
  }

  setNomeResponsavel(resposavel) {
    if (resposavel === undefined || resposavel === null) {
      this.setState({
        responsavelNome: "",
        responsavelBairro: "",
        responsavelCep: "",
        responsavelEndereco: "",
        responsavelNumero: "",
        responsavelComplemento: "",
        responsavelCidade: "",
        responsavelUF: "",
        responsavelTelefone: "",
        responsavelFax: "",
        responsavelId: null,
        responsavelEmail: "",
        documentoResp: "",
      });
    } else {
      const documento = resposavel.cpfCnpjFormatado;

      this.setState(
        {
          responsavelNome: resposavel.nome,
          responsavelBairro: resposavel.bairro.descricao,
          responsavelCep: resposavel.cep,
          responsavelEndereco: resposavel.endereco,
          responsavelNumero: resposavel.numero,
          responsavelComplemento: resposavel.complemento,
          responsavelCidade: resposavel.cidade,
          responsavelUF: resposavel.uf,
          responsavelTelefone: resposavel.telefone,
          responsavelFax: resposavel.celular,
          responsavelId: resposavel.sequencial,
          responsavelEmail: resposavel.email,
          documentoResp: documento,
        },
        () => this.formRef.current.instance.getEditor("responsavelId").focus()
      );
    }
  }

  setNomeResponsavelErro() {
    this.setState({ _uiNomeResponsavel: "<<ERRO>>" });
  }

  onResponsavelSelecionadoPesquisa(e) {
    this.setState({
      responsavelId: e.row.data.sequencial,
      popupResponsavelVisivel: false,
    });
    this.atualizarNomeResponsavel();
  }

  setImovelId(e) {
    if (e.event) {
      this.imovelDs
        .load({ filter: ["sequencial", "=", e.value] })
        .then((resp) => {
          if (resp.length > 0) {
            this.onImovelSelecioando(null, resp[0]);
          } else {
            const novoEstado = {
              enderecoDaObra: {
                imovelId: null,
                endereco: "",
                numero: "",
                complemento: "",
                bairro: "",
              },
              areaExistente: null,
            };
            this.setState(novoEstado);
          }
        })
        .catch((error) => ShowError(error));
    }
  }

  onImovelSelecioando(e, imovelDireto) {
    const imovel = imovelDireto ?? e.row.data;
    const novoEstado = {
      popupImovelVisivel: false,
      imovelId: imovel.sequencial,
      obraEndereco: imovel.logradouro.nomeCompleto,
      obraNumero: imovel.numero,
      obraComplemento: imovel.complemento,
      obraBairro: imovel.bairro.descricao,
      obraCep: imovel.cep,
      areaExistente: imovel.areaEdificada,
    };
    this.setState(novoEstado);
  }

  pesquisarResponsavel() {
    this.responsavelBoxRef.current.limparFiltro();
    this.setState({ popupResponsavelVisivel: true });
  }
  /*
  /*
  */
  //Fim das funções do responsável

  renderOutroEndereco() {
    if (this.state.enviarParaOutroEndereco) {
      return (
        <GroupItem
          caption="ENDEREÇO DE CORRESPONDÊNCIA DO PROPRIETÁRIO"
          colSpan={4}
          colCount={8}
        >
          <SimpleItem
            colSpan={1}
            dataField={"proprietarioCepC"}
            editorOptions={{ mask: "00000-000" }}
          >
            <Label text="CEP" />
          </SimpleItem>
          <SimpleItem colSpan={6} dataField={"proprietarioEnderecoC"}>
            <Label text="Endereço" />
          </SimpleItem>
          <SimpleItem colSpan={1} dataField={"proprietarioNumeroC"}>
            <Label text="Número" />
          </SimpleItem>
          <SimpleItem colSpan={2} dataField={"proprietarioComplementoC"}>
            <Label text="Complemento" />
          </SimpleItem>
          <SimpleItem colSpan={2} dataField={"proprietarioBairroC"}>
            <Label text="Bairro" />
          </SimpleItem>

          <SimpleItem colSpan={3} dataField={"proprietarioCidadeC"}>
            <Label text="Cidade" />
          </SimpleItem>
          <SimpleItem colSpan={1} dataField={"proprietarioUFC"}>
            <Label text="UF" />
          </SimpleItem>
        </GroupItem>
      );
    } else return null;
  }

  renderDadosResponsavel() {
    if (
      this.state.responsavelExecObra !== undefined &&
      this.state.responsavelExecObra !== 1
    ) {
      return (
        <GroupItem
          caption="DADOS DO RESPONSÁVEL PELA OBRA"
          colSpan={4}
          colCount={8}
        >
          <SimpleItem
            dataField={"responsavelId"}
            editorType={"dxNumberBox"}
            editorOptions={this.responsavelIdOptions}
          >
            <Label text="Código" />
          </SimpleItem>
          <SimpleItem
            dataField={"responsavelNome"}
            colSpan={6}
            editorOptions={{ readOnly: true }}
          >
            <Label text="Nome" />
          </SimpleItem>
          <SimpleItem
            colSpan={2}
            dataField={"documentoResp"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="CPF/CNPJ" />
          </SimpleItem>
          <SimpleItem
            colSpan={1}
            dataField={"responsavelCep"}
            editorOptions={{ mask: "00000-000", readOnly: true }}
          >
            <Label text="CEP" />
          </SimpleItem>
          <SimpleItem
            colSpan={4}
            dataField={"responsavelEndereco"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="Logradouro" />
          </SimpleItem>
          <SimpleItem
            colSpan={1}
            dataField={"responsavelNumero"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="N.º" />
          </SimpleItem>
          <SimpleItem
            colSpan={2}
            dataField={"responsavelComplemento"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="Complemento" />
          </SimpleItem>
          <SimpleItem
            colSpan={2}
            dataField={"responsavelCidade"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="Cidade" />
          </SimpleItem>
          <SimpleItem
            colSpan={1}
            dataField={"responsavelUF"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="UF" />
          </SimpleItem>
          <SimpleItem
            colSpan={1}
            dataField={"responsavelTelefone"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="Telefone" />
          </SimpleItem>
          <SimpleItem
            colSpan={1}
            dataField={"responsavelCelular"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="Celular" />
          </SimpleItem>
          <SimpleItem
            colSpan={3}
            dataField={"responsavelEmail"}
            editorOptions={{ readOnly: true }}
          >
            <Label text="Email" />
          </SimpleItem>
        </GroupItem>
      );
    }
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.alvaraConstrucaoDs
          .load({ filter: [["sequencial", "=", this.props.match.params.id]] })
          .then((response) => {
            if (response.length < 1) {
              notify("Registro não encontrado.", "error");
              this.props.history.goBack();
            } else {
              const data = response[0];
              const construcao = data.detalheConstrucao;

              let novoEstado = {
                alvaraAnterior: construcao.alvaraAnterior,
                ano: construcao.ano,
                areaExistente: construcao.areaExistente,
                arquiteto: construcao.arquiteto,
                artObra: construcao.artObra,
                artProjeto: construcao.artProjeto,
                classe: construcao.classe,
                codigoSituacaoDeLancamento: data.situacaoStr,
                creaArquiteto: construcao.creaArquiteto,
                creaEngenheiro: construcao.creaEngenheiro,
                dataDeCadastro: construcao.dataDeCadastro,
                dataInicioObra: construcao.dataInicioObra,
                dataTerminoObra: construcao.dataTerminoObra,
                documento: construcao.proprietario.documento,
                documentoResp:
                  construcao.responsavel == undefined
                    ? undefined
                    : construcao.responsavel.documento,
                engenheiro: construcao.engenheiro,
                especificacao: construcao.especificacao,
                id: data.id,
                sequencial: data.sequencial,
                indicaoFiscal: construcao.indicaoFiscal,
                m2DoAcrescimo: construcao.m2DoAcrescimo,
                m2DaConstrucao: construcao.m2DaConstrucao,
                m2DaDemolicao: construcao.m2DaDemolicao,
                m2DaReforma: construcao.m2DaReforma,
                numero: data.numeroLancamento,
                obraBairro: construcao.obraBairro,
                obraCep: construcao.obraCEP,
                obraComplemento: construcao.obraComplemento,
                obraEmail: construcao.obraEmail,
                obraEndereco: construcao.obraEndereco,
                obraFax: construcao.obraFax,
                obraNome: construcao.obraNome,
                obraNumero: construcao.obraNumero,
                obraTelefone: construcao.obraTelefone,
                observacao: construcao.observacao,
                pavimentos: construcao.pavimentos,
                processo: construcao.processo,
                proprietarioNome: data.contribuinte.nome,
                proprietarioBairro: data.contribuinte.bairro.descricao,
                proprietarioCep: data.contribuinte.cep,
                proprietarioEndereco: data.contribuinte.endereco,
                proprietarioNumero: data.contribuinte.numero,
                proprietarioComplemento: data.contribuinte.complemento,
                proprietarioCidade: data.contribuinte.cidade,
                proprietarioUF: data.contribuinte.uf,
                proprietarioTelefone: data.contribuinte.telefone,
                proprietarioFax: data.contribuinte.celular,
                proprietarioId: data.contribuinte.sequencial,
                proprietarioEmail: construcao.proprietarioEmail,
                proprietarioBairroC: construcao.proprietarioBairroC,
                proprietarioCepC: construcao.proprietarioCEPC,
                proprietarioEnderecoC: construcao.proprietarioEnderecoC,
                proprietarioNumeroC: construcao.proprietarioNumeroC,
                proprietarioComplementoC: construcao.proprietarioComplementoC,
                proprietarioCidadeC: construcao.proprietarioCidadeC,
                proprietarioUFC: construcao.proprietarioUFC,
                qtdeSimples: construcao.qtdeBCSimples,
                responsavelBairro: construcao.responsavelBairro,
                responsavelCEP: construcao.responsavelCEP,
                responsavelCidade: construcao.responsavelCidade,
                responsavelComplemento: construcao.responsavelComplemento,
                responsavelEndereco: construcao.responsavelEndereco,
                responsavelExecObra: construcao.respExecObra,
                responsavelId:
                  construcao.respExecObra == 1
                    ? null
                    : construcao.responsavel.sequencial,
                responsavelNumero: construcao.responsavelNumero,
                responsavelUF: construcao.responsavelUF,
                situacao: construcao.anotacaoSituacao,
                tipoConstrucaoSimples: construcao.tipoConstrucaoSimples,
                tipoDeConstrucaoDaConstrucao:
                  construcao.tipoDeConstrucaoDaConstrucao,
                tipoDeConstrucaoDaDemolicao:
                  construcao.tipoDeConstrucaoDaDemolicao,
                tipoDeConstrucaoDaReforma: construcao.tipoDeConstrucaoDaReforma,
                tipoDeConstrucaoDoAcrescimo:
                  construcao.tipoDeConstrucaoDoAcrescimo,
                tipoDeOcupacaoDaConstrucao:
                  construcao.tipoDeOcupacaoDaConstrucao,
                tipoDeOcupacaoDaDemolicao: construcao.tipoDeOcupacaoDaDemolicao,
                tipoDeOcupacaoDaReforma: construcao.tipoDeOcupacaoDaReforma,
                tipoDeOcupacaoDoAcrescimo: construcao.tipoDeOcupacaoDoAcrescimo,
                tipoId: construcao.tipoAlvaraConstrucaoId,
                tipoOcupacaoSimples: construcao.ocupacaoSimples,
                unidadeMedidaBCSimples:
                  construcao.tipoAlvaraConstrucao.unidadeBaseCalculo,
                unidades: construcao.unidades,
                validade: data.validadeLancamento,
                vencimento: data.vencimentoAlvara,
                zonaObra: construcao.zonaObra,
                imovelId:
                  data.imovelId != undefined
                    ? data.imovel.sequencial
                    : undefined,
                popupProprietarioVisivel: false,
                popupResponsavelVisivel: false,
                enviarParaOutroEndereco: construcao.enviarParaOutroEndereco,
                _uiClasse: construcao.tipoAlvaraConstrucao.classe,
                _uiNumeroAlvara: data.numeroCompleto,
                exibirPopupPreview: false,
                responsavelCalculoNome: construcao.responsavelCalculoNome,
                creaResponsavelCalculo: construcao.creaResponsavelCalculo,
                cpfRespsonavelProjArq: construcao.cpfRespsonavelProjArq,
                cpfResponsavelCalculo: construcao.cpfResponsavelCalculo,
                cpfResponsavelObra: construcao.cpfResponsavelObra,
              };
              this.setState(novoEstado);
            }
          })
          .catch((erro) => {
            ShowError(erro);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form
              formData={this.state}
              colCount={4}
              labelLocation={"top"}
              ref={this.formRef}
            >
              <GroupItem caption="INFORMAÇÕES DA OBRA" colSpan={4} colCount={8}>
                <SimpleItem
                  colSpan={1}
                  dataField={"_uiNumeroAlvara"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Nº do Alvará" />
                </SimpleItem>
                <SimpleItem
                  dataField={"dataDeCadastro"}
                  editorType={"dxDateBox"}
                  colSpan={1}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Data Alvará" />
                </SimpleItem>
                <SimpleItem colSpan={2} dataField={"obraNome"}>
                  <Label text="Nome da Obra" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"tipoId"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tiposAlvaraOptions}
                >
                  <Label text="Tipo de Alvará" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"responsavelExecObra"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.responsavelOptions}
                >
                  <Label text="Responsável" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="PROPRIETÁRIO" colSpan={4} colCount={8}>
                <SimpleItem
                  dataField={"proprietarioId"}
                  editorType={"dxNumberBox"}
                  editorOptions={this.proprietarioOptions}
                >
                  <Label text="Código" />
                </SimpleItem>
                <SimpleItem
                  dataField={"proprietarioNome"}
                  colSpan={6}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Nome" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"documento"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="CPF/CNPJ" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"proprietarioCep"}
                  editorOptions={{ mask: "00000-000", readOnly: true }}
                >
                  <Label text="CEP" />
                </SimpleItem>
                <SimpleItem
                  colSpan={4}
                  dataField={"proprietarioEndereco"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Logradouro" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"proprietarioNumero"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="N.º" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"proprietarioComplemento"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Complemento" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"proprietarioCidade"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Cidade" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"proprietarioUF"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="UF" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"proprietarioTelefone"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Telefone" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"proprietarioFax"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Fax" />
                </SimpleItem>
                <SimpleItem
                  colSpan={3}
                  dataField={"proprietarioEmail"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Email" />
                </SimpleItem>
                <SimpleItem
                  editorType={"dxCheckBox"}
                  dataField={"enviarParaOutroEndereco"}
                  editorOptions={{
                    onValueChanged: (e) =>
                      this.setState({ enviarParaOutroEndereco: e.value }),
                  }}
                >
                  <Label
                    text="Enviar correspondências para outro endereço"
                    location={"right"}
                  />
                </SimpleItem>
              </GroupItem>

              {this.renderOutroEndereco()}

              {this.renderDadosResponsavel()}

              <GroupItem caption="ENDEREÇO DA OBRA" colSpan={4} colCount={8}>
                <SimpleItem
                  colSpan={1}
                  dataField={"obraCep"}
                  editorOptions={{ mask: "00000-000" }}
                >
                  <Label text="CEP" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"zonaObra"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.zonaObraOptions}
                >
                  <Label text="Zona" />
                </SimpleItem>
                <SimpleItem
                  editorType={"dxTextBox"}
                  colSpan={1}
                  dataField={"imovelId"}
                  editorOptions={this.imovelOptions}
                >
                  <Label text="Imóvel" />
                </SimpleItem>
                <SimpleItem colSpan={4} dataField={"obraEndereco"}>
                  <Label text="Endereço" />
                </SimpleItem>
                <SimpleItem colSpan={1} dataField={"obraNumero"}>
                  <Label text="Número" />
                </SimpleItem>
                <SimpleItem colSpan={2} dataField={"obraComplemento"}>
                  <Label text="Complemento" />
                </SimpleItem>
                <SimpleItem colSpan={2} dataField={"obraBairro"}>
                  <Label text="Bairro" />
                </SimpleItem>
                <SimpleItem colSpan={1} dataField={"obraTelefone"}>
                  <Label text="Telefone" />
                </SimpleItem>
                <SimpleItem colSpan={1} dataField={"obraFax"}>
                  <Label text="Fax" />
                </SimpleItem>
                <SimpleItem colSpan={2} dataField={"obraEmail"}>
                  <Label text="E-mail" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="ESPECIFICAÇÃO" colSpan={4} colCount={3}>
                <SimpleItem
                  dataField={"especificacao"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "160px" }}
                  colSpan={3}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="INFORMAÇÕES BÁSICAS" colSpan={4} colCount={4}>
                <SimpleItem colSpan={1} dataField={"unidades"}>
                  <Label text="Nº Unidades" />
                </SimpleItem>
                <SimpleItem colSpan={1} dataField={"pavimentos"}>
                  <Label text="Nº Pavimentos" />
                </SimpleItem>
                <SimpleItem
                  dataField={"dataInicioObra"}
                  editorType={"dxDateBox"}
                  colSpan={1}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Início da Obra" />
                </SimpleItem>
                <SimpleItem
                  dataField={"dataTerminoObra"}
                  editorType={"dxDateBox"}
                  colSpan={1}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Término da Obra" />
                </SimpleItem>
                <SimpleItem
                  dataField={"vencimento"}
                  editorType={"dxDateBox"}
                  colSpan={1}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Data de Vencimento" />
                </SimpleItem>
                <SimpleItem
                  dataField={"validade"}
                  editorType={"dxDateBox"}
                  colSpan={1}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Validade" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"areaExistente"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Área Existente" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"unidadeMedidaBCSimples"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Unid. Base de Cálculo" />
                </SimpleItem>
              </GroupItem>

              {/* OBS JOHN 1 Grupo de Alvará Avançado, somente visível se classe do tipo  = 0 */}

              <GroupItem caption="Cálculo" visible={this.state._uiClasse == 1}>
                <SimpleItem
                  colSpan={1}
                  dataField={"tipoOcupacaoSimples"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.ocupacaoOptions}
                >
                  <Label text="Tipo de Ocupação" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"tipoConstrucaoSimples"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.construcaoOptions}
                >
                  <Label text="Tipo da Construção" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"qtdeSimples"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label
                    text={`Quantidade (${this.state.unidadeMedidaBCSimples})`}
                  />
                </SimpleItem>
              </GroupItem>

              <GroupItem
                colSpan={4}
                colCount={4}
                visible={this.state._uiClasse == 0}
              >
                <GroupItem caption="CONSTRUÇÃO NOVA">
                  <SimpleItem
                    colSpan={1}
                    dataField={"tipoDeOcupacaoDaConstrucao"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.ocupacaoOptions}
                  >
                    <Label text="Tipo de Ocupação" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"tipoDeConstrucaoDaConstrucao"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.construcaoOptions}
                  >
                    <Label text="Tipo da Construção" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"m2DaConstrucao"}>
                    <Label text="Área(m²)" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="DEMOLIÇÃO">
                  <SimpleItem
                    colSpan={1}
                    dataField={"tipoDeOcupacaoDaDemolicao"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.ocupacaoOptions}
                  >
                    <Label text="Tipo de Ocupação" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"tipoDeConstrucaoDaDemolicao"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.construcaoOptions}
                  >
                    <Label text="Tipo da Construção" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"m2DaDemolicao"}>
                    <Label text="Área(m²)" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="ACRÉSCIMO">
                  <SimpleItem
                    colSpan={1}
                    dataField={"tipoDeOcupacaoDoAcrescimo"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.ocupacaoOptions}
                  >
                    <Label text="Tipo de Ocupação" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"tipoDeConstrucaoDoAcrescimo"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.construcaoOptions}
                  >
                    <Label text="Tipo da Construção" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"m2DoAcrescimo"}>
                    <Label text="Área(m²)" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="REFORMA">
                  <SimpleItem
                    colSpan={1}
                    dataField={"tipoDeOcupacaoDaReforma"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.ocupacaoOptions}
                  >
                    <Label text="Tipo de Ocupação" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"tipoDeConstrucaoDaReforma"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.construcaoOptions}
                  >
                    <Label text="Tipo da Construção" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"m2DaReforma"}>
                    <Label text="Área(m²)" />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>

              <GroupItem colSpan={this._uiClasse == 0 ? 4 : 3} colCount={4}>
                <GroupItem caption="INFORMAÇÕES ADICIONAIS">
                  <SimpleItem colSpan={2} dataField={"situacao"}>
                    <Label text="Situação" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"classe"}>
                    <Label text="Classe" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"alvaraAnterior"}>
                    <Label text="Nº Alvará Anterior" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"processo"}>
                    <Label text="Nº Processo" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"indicaoFiscal"}>
                    <Label text="Nº Indicação Fiscal" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="OBRA" colSpan={1} colCount={1}>
                  <SimpleItem colSpan={1} dataField={"engenheiro"}>
                    <Label text="Nome Resp. Obra" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"creaEngenheiro"}>
                    <Label text="CREA" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"cpfResponsavelObra"}>
                    <Label text="CPF" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"artObra"}>
                    <Label text="Nº ART Obra" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="PROJETO" colSpan={1} colCount={1}>
                  <SimpleItem colSpan={1} dataField={"arquiteto"}>
                    <Label text="Nome Resp. Projeto" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"creaArquiteto"}>
                    <Label text="CREA" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"cpfRespsonavelProjArq"}>
                    <Label text="CPF" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"artProjeto"}>
                    <Label text="Nº ART Projeto" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="CALCULO" colSpan={1} colCount={1}>
                  <SimpleItem colSpan={1} dataField={"responsavelCalculoNome"}>
                    <Label text="Nome Resp. Cálculo" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"creaResponsavelCalculo"}>
                    <Label text="CREA" />
                  </SimpleItem>
                  <SimpleItem colSpan={1} dataField={"cpfResponsavelCalculo"}>
                    <Label text="CPF" />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>

              <GroupItem caption="OBSERVAÇÃO" colSpan={4}>
                <SimpleItem
                  dataField={"observacao"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "120px" }}
                  colSpan={3}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Pré-visualizar"
                  type="default"
                  onClick={this.confirmarTela}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.confirmarPopup}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} width={120} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupProprietarioVisivel}
            onHiding={() => this.setState({ popupProprietarioVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Proprietário"
          >
            <ScrollView>
              <ContribuinteBox
                onSelecionado={this.onProprietarioSelecionadoPesquisa}
                ref={this.proprietarioBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () =>
                  this.setState({ popupProprietarioVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.popupResponsavelVisivel}
            onHiding={() => this.setState({ popupResponsavelVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Responsável"
          >
            <ScrollView>
              <ContribuinteBox
                onSelecionado={this.onResponsavelSelecionadoPesquisa}
                ref={this.responsavelBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () =>
                  this.setState({ popupResponsavelVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.popupImovelVisivel}
            onHiding={() => this.setState({ popupImovelVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Imóvel"
          >
            <ScrollView>
              <ImovelBox
                onSelecionado={this.onImovelSelecioando}
                ref={this.imovelBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupImovelVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.exibirPopupPreview}
            onHiding={() => this.setState({ exibirPopupPreview: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={600}
            height={350}
            title="Confirmação dos dados"
          >
            <ScrollView showScrollbar="always">
              <form>
                <Form formData={this.state.previewData}>
                  <SimpleItem dataField={"nome"} render={this.itemLeitura}>
                    <Label text="Nome" />
                  </SimpleItem>

                  <SimpleItem dataField={"cpfCnpj"} render={this.itemLeitura}>
                    <Label text="CPF/CNPJ" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL1"}
                    render={this.itemLeitura}
                  >
                    <Label text="Endereco" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL2"}
                    render={this.itemLeitura}
                  >
                    <Label text=" " showColon={false} />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"valor"}
                    render={this.itemLeituraMoeda}
                  >
                    <Label text="Valor" />
                  </SimpleItem>
                </Form>
              </form>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: this.confirmarPopup,
              }}
            ></ToolbarItem>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Cancelar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPopupPreview: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  confirmarTela() {
    this.confirmar(true);
  }

  confirmarPopup() {
    this.confirmar(false);
  }

  confirmar(preview) {
    const entidade = {
      ...this.state,
      prefeituraId: UserInfo.getPrefeitura(),
      preview,
    };
    inserirOuAtualizar(this.alvaraConstrucaoDs, entidade).then((resp) => {
      _cadastroCorrente = undefined;
      _cancelando = true;
      if (!preview) {
        notify("Alvará de construção cadastrado com sucesso.", "success");
        abrirDetalhe(this.props.history, resp);
      } else {
        const contribuinte = resp.lancamento.contribuinte;
        this.setState({
          exibirPopupPreview: true,
          previewData: {
            nome: contribuinte.nome,
            cpfCnpj: contribuinte.documentoFormatado,
            enderecoL1: contribuinte.logradouroComNumero,
            enderecoL2: contribuinte.enderecoL2,
            valor: resp.lancamento.valorDoImposto,
          },
        });
      }
    });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
